import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20style%20banner%20with%20cherry%20blossom%20petals%20floating%20in%20spring%20breeze%2C%20warm%20golden%20sunset%20sky%2C%20silhouette%20of%20adventurous%20character%20looking%20at%20distant%20horizon%2C%20cinematic%20composition%2C%20soft%20dreamy%20atmosphere%2C%20Japanese%20anime%20aesthetic%2C%20minimalist%20design&width=1600&height=700&seq=hero-slide-01&orientation=landscape',
    title: '葬送的芙莉莲',
    subtitle: '一段关于时间、生命与羁绊的静美之旅',
    link: '/category/riman',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20banner%20with%20modern%20Japanese%20cityscape%20at%20night%2C%20colorful%20neon%20signs%2C%20sakura%20petals%20dancing%2C%20urban%20fantasy%20atmosphere%2C%20young%20characters%20in%20school%20uniforms%2C%20cinematic%20lighting%2C%20Japanese%20anime%20style&width=1600&height=700&seq=hero-slide-02&orientation=landscape',
    title: '咒术回战 第二季',
    subtitle: '涩谷事变震撼开幕，最强咒术师五条悟登场',
    link: '/category/riman',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20anime%20banner%20with%20ink%20wash%20painting%20style%2C%20traditional%20Chinese%20landscape%20mountains%2C%20misty%20atmosphere%2C%20swordsman%20character%20in%20dynamic%20pose%2C%20elegant%20brushwork%2C%20artistic%20composition%2C%20donghua%20aesthetic&width=1600&height=700&seq=hero-slide-03&orientation=landscape',
    title: '雾山五行',
    subtitle: '国风美学巅峰之作，水墨画般的视觉盛宴',
    link: '/category/guoman',
  },
];

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 w-full">
          <div className="max-w-lg">
            <h1 className="text-2xl md:text-4xl font-heading text-background-50 leading-tight">
              {slides[current].title}
            </h1>
            <p className="mt-3 text-sm md:text-base text-background-200 leading-relaxed">
              {slides[current].subtitle}
            </p>
            <div className="flex items-center gap-3 mt-6">
              <Link
                to={slides[current].link}
                className="inline-flex px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即观看
              </Link>
              <Link
                to="/categories"
                className="inline-flex px-6 py-2.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                探索更多
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === current ? 'w-6 bg-primary-500' : 'bg-background-50/50'
            }`}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}